/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Infrastructure
 * @graph-business アプリケーション設定定数。API URL・アプリ名・対応言語・TanStack Queryデフォルト値を定義
 * @graph-connects none
 */
export const config = {
  /** API base URL */
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',

  /** アプリケーション名 */
  appName: 'LINE User ID Resolver' as const,

  /** デフォルト言語 */
  defaultLanguage: 'ja',

  /** サポート言語 */
  supportedLanguages: ['ja', 'en'] as const,

  /** TanStack Query のデフォルト設定 */
  query: {
    staleTime: 5 * 60 * 1000, // 5分
    gcTime: 10 * 60 * 1000, // 10分（旧cacheTime）
    retry: 1,
    refetchOnWindowFocus: false,
  },
} as const;

export type SupportedLanguage = (typeof config.supportedLanguages)[number];
